module.exports = __webpack_public_path__ + "img/world.81cf9992.svg";